import { render } from "./ContentModal.vue?vue&type=template&id=00a6d37b&ts=true"
import script from "./ContentModal.vue?vue&type=script&lang=ts"
export * from "./ContentModal.vue?vue&type=script&lang=ts"

import "./ContentModal.vue?vue&type=style&index=0&id=00a6d37b&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__